import { mdiAttachment, mdiTrayArrowDown } from "@mdi/js";
import Icon from "@mdi/react";

import { VisibilitySVGIcon } from "components/SVGIcons";
import { ICarrierAttachment } from "models/HaulPay";

type CarrierNoaAttachmentProps = {
  attachment?: ICarrierAttachment | null;
};

const actionClassName =
  "grid w-12 h-8 rounded place-items-center text-text desktop:text-modalBg bg-foreground desktop:bg-iconDarkBtn";

export default function CarrierNoaAttachment({ attachment }: Readonly<CarrierNoaAttachmentProps>) {
  const previewUrl = attachment?.preview_url || attachment?.download_url;

  return (
    <li className="flex flex-col gap-1">
      <span>Carrier’s NOA</span>
      {attachment ? (
        <div className="flex gap-2.5">
          <div className="flex min-w-0 gap-2 min-h-8 pl-3 pr-4 bg-transparent border rounded border-tertiary desktop:border-subtitle desktop:text-iconButton">
            <Icon
              path={mdiAttachment}
              className="flex-none my-auto -rotate-30 text-placeholder size-4"
            />
            <span className="my-auto truncate" title={attachment.filename}>
              {attachment.filename}
            </span>
          </div>

          {previewUrl ? (
            <a
              href={previewUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`View ${attachment.filename}`}
              className={actionClassName}>
              <VisibilitySVGIcon />
            </a>
          ) : (
            <button
              type="button"
              disabled
              aria-label="Preview unavailable"
              className={actionClassName}>
              <VisibilitySVGIcon />
            </button>
          )}

          {attachment.download_url ? (
            <a
              href={attachment.download_url}
              download={attachment.filename}
              aria-label={`Download ${attachment.filename}`}
              className={actionClassName}>
              <Icon path={mdiTrayArrowDown} className="size-5" />
            </a>
          ) : (
            <button
              type="button"
              disabled
              aria-label="Download unavailable"
              className={actionClassName}>
              <Icon path={mdiTrayArrowDown} className="size-5" />
            </button>
          )}
        </div>
      ) : (
        <span className="text-sm text-placeholder">No NOA attachment available</span>
      )}
    </li>
  );
}
